// ---------- import extenal dependencies ----------
import React from "react";
import { Link, useLocation } from "react-router-dom";

// ----------- import internal dependencies ---------
import "./sidenav.scoped.css";
import { ReactComponent as Dashboard } from "../../asset/img/svg/dashboard.svg";
import { ReactComponent as Parent } from "../../asset/img/svg/user.svg";
import { ReactComponent as Student } from "../../asset/img/svg/education.svg";
import { ReactComponent as Class } from "../../asset/img/svg/class.svg";
import { ReactComponent as Ticket } from "../../asset/img/svg/ticket.svg";
import { ReactComponent as Settings } from "../../asset/img/svg/settings.svg";
import { ReactComponent as Audit } from "../../asset/img/svg/audit.svg";
import Button from "../Button";

const routes = [
  {
    path: "/dashboard",
    icon: Dashboard,
    name: "dashboard",
    tag: "dashboard",
  },
  {
    path: "/school/parent",
    icon: Parent,
    name: "parent / Guardian",
    tag: "parent",
    addFill: true,
  },
  {
    path: "/school/student",
    icon: Student,
    name: "student",
    tag: "student",
    addFill: true,
  },
  {
    path: "/school/class",
    icon: Class,
    name: "class",
    tag: "class",
  },
  {
    path: "/school/report",
    icon: Ticket,
    name: "report",
    tag: "report",
  },
  {
    path: "/school/ticket",
    icon: Ticket,
    name: "ticket",
    tag: "ticket",
    addFill: true,
  },
  {
    path: "/school/account",
    icon: Audit,
    name: "account",
    tag: "account",
  },
  {
    path: "/school/settings",
    icon: Settings,
    name: "settings",
    tag: "settings",
    addFill: true,
  },
];

function SideNav() {
  // ---------- invoke component hooks helper ---------
  const location = useLocation();

  const { pathname } = location;
  const splitedPaths = pathname.split("/");
  // console.log(splitedPaths, "llk");
  console.log("/school/parent".split("/"), "llk2");

  return (
    <>
      <aside className="sidenav">
        <nav>
          <div className="sidenav-brand">
            <img src="/asset/img/logo.svg" alt="Secure-school brand" />
            <span>Secure School</span>
          </div>
          <ul className="sidenav-links">
            {routes.map((item, i) => (
              <li
                key={i}
                className={`${
                  splitedPaths.includes(item.tag) ? "active-link" : ""
                } hover:`}
              >
                <Link to={item.path} className="">
                  <item.icon
                    stroke={
                      !splitedPaths.includes(item.tag) ? "#818d8a" : "#19ba93"
                    }
                    fill={
                      item.addFill
                        ? `${
                            splitedPaths.includes(item.tag)
                              ? "#19ba93"
                              : "#818d8a"
                          }`
                        : "none"
                    }
                  />
                  <span> {item.name}</span>
                </Link>
              </li>
            ))}
          </ul>
          <div className="advert-box">
            <img src="/asset/img/sec-schl.svg" alt="Advert" />
            <span>Place different types of adverts here!</span>
            <Button white addClass="mx-auto mt-2">
              Get started
            </Button>
          </div>
        </nav>
      </aside>
    </>
  );
}

export default SideNav;
